/**
 * @description 导入所有 vuex 模块，自动加入namespaced:true，用于解决vuex命名冲突，请勿修改。
 */

import Vue from 'vue';
import Vuex from 'vuex';

import app from './modules/app';
import cms from './modules/cms';
import error from './modules/error';
import routes from './modules/routes';
import settings from './modules/settings';
import unsplash from './modules/unsplash';
import user from './modules/user';
import requestCont from './modules/requestCont';
import lowcode from './modules/lowcode';
import member from './modules/member';
import numberPortal from '@@/store/modules/numberPortal';
import globalActions from '@@/store/modules/globalActions';
import media from './modules/media';
import aicockpit from './modules/aicockpit';

import createPersistedstate from 'vuex-persistedstate' // 持久化存储

Vue.use(Vuex);

const modules = {
    app,
    cms,
    error,
    routes,
    settings,
    unsplash,
    user,
    requestCont,
    lowcode,
    member,

    numberPortal,
    globalActions,
    media,
    aicockpit,
};

Object.keys(modules).forEach(key => {
    if (!['globalActions'].includes(key)) {
        modules[key]['namespaced'] = true;
    }
});

const store = new Vuex.Store({
    state: {
        $is2024: true,
    },
    mutations: {
        SET_IS2024(state, status) {
            state.$is2024 = status;
        }
    },   
    getters: {
        $is2024: (state) => state.$is2024
    },   
    // actions: {
    //     setVersion({ commit }, state) {
    //         commit('SET_IS2024', state);
    //     }, 
    // },     
    modules,
    plugins: [
        createPersistedstate({
            key: 'numberPortal',
            paths: ['numberPortal'],
            storage: window.localStorage
        })
    ]

});

export default store;
